import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { orderBy } from 'lodash';
import { CommentReactionsComponent } from './comment-reactions/comment-reactions.component';
import { EMOTICON_REACTION_DEFS, EmoticonReaction } from './emoticon-reactions/emoticon-reaction.type';
import { EmoticonReactionsButtonComponent } from './emoticon-reactions/emoticon-reactions-button.component';
import { EmoticonReactionsComponent } from './emoticon-reactions/emoticon-reactions.component';
import { ReactionService } from './reaction.service';
import {
  Reaction,
  ReactionId,
  Reactions,
  ReactionsEnum,
  Thread,
  Threads,
  TimelineItemType
} from "../timeline-item.types";

const REACT_OPTIONS = [...EMOTICON_REACTION_DEFS.values()].filter(reaction => reaction.id !== ReactionsEnum.care);

@Component({
    selector: 'tm-reactions',
    templateUrl: './reactions.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommentReactionsComponent,
        CommonModule,
        EmoticonReactionsComponent,
        EmoticonReactionsButtonComponent,
        TranslateModule
    ]
})
export class ReactionsComponent {
  private _timelineItem:{id: string, itemType: TimelineItemType} & Reactions & Threads;
  private _reactions: EmoticonReaction[];
  currentReaction: EmoticonReaction;

  REACT_OPTIONS = REACT_OPTIONS;

  @Input({ required: true })
  set timelineItem(item: {id: string, itemType: TimelineItemType} & Reactions & Threads) {
    this._timelineItem = item;
    this.reactions = item.reactions;
    this.threads = item.threads;
  }

  set reactions(reactions: Reaction[]) {
    if (reactions) {
      this._reactions = orderBy(this.reactionService.mapToEmoticonReactions(reactions), ['count'], ['desc']);
      this.currentReaction = this._reactions.find(reaction => reaction.selected);
    }
  }

  get reactions(): EmoticonReaction[] {
    return this._reactions;
  }


  @Input()
  showDiscussButton: boolean = true;

  threads: Thread[];

  @Input() reactionType: 'care' | 'react' | 'none' = 'react';

  @Input() discussLabel = 'comment-card.discuss';

  @Output()
  onReacted = new EventEmitter<{id: string, itemType: TimelineItemType} & Reactions>();
  
  @Output()
  onToggleThreads = new EventEmitter<void>();

  @Output()
  onDiscuss = new EventEmitter<void>();
  
  constructor(
    private reactionService: ReactionService
  ) { }

  care() {
    this.react(ReactionsEnum.care);
  }

  async react(reaction: ReactionId) {
    if (reaction) {
      const updatedItem = await this.reactionService.react(this._timelineItem.id, this._timelineItem.itemType, reaction)
      this.reactions = updatedItem.reactions;
      this.onReacted.next( updatedItem )
    }
  }

  toggleThreads() {
    this.onToggleThreads.next();
  }
}